// libs
import React from 'react';

// components
import { Box } from '@lyearn/ui';

import Order from './components/Order';
import ScoreBox from './components/ScoreBox';
import TitleInput from './components/TitleInput';
// types
import { QuestionEditorProps } from './types';

function QuestionEditor({ error, question, className, onChange }: QuestionEditorProps) {
  const { tempId, order, maxScore } = question;

  return (
    <Box className={className}>
      <Order className="ms-8" order={order} />
      <TitleInput error={error} question={question} onChange={onChange} />
      <ScoreBox maxScore={maxScore} questionId={tempId} />
    </Box>
  );
}

export default React.memo(QuestionEditor);
